import React, { Fragment, useContext, useState, useEffect } from "react";
import CustomContext from "../../_helper/Customizer";
import Leftbar from "./Leftbar/index";
import RightHeader from "./RightHeader/index";

// Header — yalnız iskelet: Leftbar (logo/toggle + sol ikonlar) + RightHeader
// (dil/fullscreen/reminder/ARAMA/add/bildirim/mesaj).
//
// Scroll'da yumuşakça KOMPAKT görünüme geçer, en üste/yukarı çıkınca genişler
// (`.is-compact` class + CSS geçişi). Hysteresis (>48 kompakt, <14 genişle) →
// eşik etrafında titreme yok.
const Header = () => {
  const { toggleIcon } = useContext(CustomContext);
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        setCompact((prev) => {
          if (!prev && y > 48) return true;
          if (prev && y < 14) return false;
          return prev;
        });
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <Fragment>
      <div
        className={`page-header ${toggleIcon ? "close_icon" : ""} ${
          compact ? "is-compact" : ""
        }`}
      >
        <div className="header-wrapper">
          <Leftbar />
          <RightHeader />
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
